import AlertsFilter from "./alerts-filter.vue";

export default AlertsFilter;



// WEBPACK FOOTER //
// ./src/components/_dashboard/alerts/filter/index.js